/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AppsAssignConnection from 'DesignSystem/AppsAssignConnection/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/ITeroCheckPatientConnection/Content/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let tabPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'patient_id',
})
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let appPropertiesIteroAppIdValueData = fromData.useDataValue({ viewPath,
context: 'app_properties',
path: 'itero_app_id',
})
let constantData = 'Align iTero™'
  return (<React.Fragment
>
<AppsAssignConnection
  viewPath={`${viewPath}/AppsAssignConnection`}
 data="tab.patient_id"
 patientId={tabPatientIdValueData}
 data="global.current_location._id"
 locationId={globalCurrentLocationIdValueData}
 data="app_properties.itero_app_id"
 appId={appPropertiesIteroAppIdValueData}
 data="'Align iTero™'"
 appName={constantData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 onSubmit={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../CreateIteroScanRequest/Content'))}
/>
{children}
</React.Fragment>)
}